// extracted by mini-css-extract-plugin
export var required = "_im-0";